import Filter from './filters';
import { $doc, loadScript } from './utils';
import { initSlider } from './sliders';
import { videoControlPlayer, $win } from './utils';

class Gallery {
	constructor() {
		this.container = $('.js-gallery');
		this.triggers = $('.js-gallery-modal-trigger');
		this.filterButtons = $('.js-filter');
		this.filtersSelect = $('.js-filter-select');
		this.sliderSelector = '.js-gallery-slider';
		this.slides = $(this.sliderSelector).find('.swiper-slide');
		this.slider = null;
		this.modal = $('#gallery-modal');

		this.filtersInst = new Filter({
			container: this.container,
			elements: this.container.children()
		});
	}

	init() {
		this.filtersInst.init();

		this.initSlider();

		this.registerEvents();
	}

	initSlider() {
		initSlider(this.sliderSelector, {
			loopAdditionalSlides: 1,
			loopedSlides: 1,
			observerUpdate: true,
			simulateTouch: true,
			autoHeight: true
		});

		this.slider = document.querySelector(this.sliderSelector + ' .swiper-container').swiper;

		this.slider.originalSlides = this.slides;
	}

	registerEvents() {
		const that = this;

		this.filterButtons.on('click', function() {
			const $this = $(this);
			const filter = $this.data('filter');

			$this
				.parent()
					.addClass('active')
				.siblings()
					.removeClass('active');

			that.startFiltering(filter);
		});

		this.filtersSelect.on('change', function() {
			const filter = $(this).val();

			that.startFiltering(filter);			
		});

		this.triggers.on('click', function() {
			const id = $(this).data('id');

			that.slideToItem(id);
		});

		this.modal.on('shown.bs.modal', function() {
			const $activeSlide = $(that.sliderSelector).find('.swiper-slide-active');
			that.slider.update();

			// Trigger iframe position re-calculation
			setTimeout(function() {
				$win.trigger('resize');

				videoControlPlayer($('iframe', $activeSlide), 'play');
			}, 400)
		});

		this.modal.on('hide.bs.modal', function() {
			const $activeSlide = $(that.sliderSelector).find('.swiper-slide-active');
			
			videoControlPlayer($('iframe', $activeSlide), 'pause');
		});

		$doc.on('keydown', function(event) {
			if (that.modal.hasClass('show')) {
				if (event.keyCode == '37') {
					// left arrow
					that.slider.slidePrev();
				}
				else if (event.keyCode == '39') {
					// right arrow
					that.slider.slideNext();
				}
			}
		});
	}

	slideToItem(id) {
		let slideIndex = 0;

		$(this.sliderSelector).find('.swiper-slide').each(function(index) {
			if ( $(this).data('id') == id ) {
				slideIndex = index;
			}
		});

		this.slider.params.speed = 0;

		this.slider.slideTo(slideIndex);

		this.slider.params.speed = 300;
	}

	startFiltering(filter) {
		if ( filter == '*' ) {
			this.filtersInst.filterReset();
		} else {
			this.filtersInst.filterByClass(filter);
		}

		this.filterSlider(filter);
	}

	filterSlider(filter) {
		this.slider.removeAllSlides();

		const visibleSlides = this.slider.originalSlides.filter((index, slide) => {
			if (filter == '*') {
				return true;
			}

			return $(slide).hasClass(filter.replace('.', ''));
		});

		$(this.sliderSelector).toggleClass('disabled', visibleSlides.length <= 1);

		this.slider.appendSlide(visibleSlides);
	}
}

export default function galleryUI() {
	loadScript('isotopeScript', window.isotopeScript, function() {
		return new Promise((resolve, reject) => {
			new Gallery().init();

			resolve();
		})
	})
}
